angular.module('app')
    .directive('createConcertOrBooking', function () {
        return {
            templateUrl: 'components/directives/create_concert_or_booking/view.create_concert_or_booking.html',
            controller: 'CreateConcertOrBookingController',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                band_slug: '<bandSlug',
                show: '='
            }
        }
    });
